import * as Yup from 'yup'

const isEmpty = value => {
  return value.trim().length === 0
}

export const validationSchema = Yup.object().shape({
  card: Yup.string()
    .min(12, 'Invalid card number')
    .matches(/^[0-9 ]*$/, 'Invalid card number')
    .test('is-empty', 'Required', value => value && !isEmpty(value)),
  expiration: Yup.string()
    .matches(/^\d{2}\/\d{2}$/, 'Invalid expiration date')
    .test('is-empty', 'Required', value => value && !isEmpty(value)),
  cvv: Yup.string()
    .matches(/^[0-9]{3,4}$/, 'Invalid CVV')
    .test('is-empty', 'Required', value => value && !isEmpty(value)),
  setDefault: Yup.boolean()
})

export const expirationDateMask = [/[0-9]/, /\d/, '/', /\d/, /\d/]



// WEBPACK FOOTER //
// ./src/modules/Checkout/PaymentDetails/utils.js